import * as _ from 'lodash';
import { IMatchRunSwap } from '@nkr/models/matching';
import { RowWrapper } from '../styles';

interface IProps {
    swaps: IMatchRunSwap[],
    deepestChainDepth: number,
    isLoopRun: boolean
}

const StringDepth = (props: IProps) => {
    const getPositionCount = (distance: number) => {
        let positionCount = 0;

        props.swaps.forEach(swap => {
            positionCount += swap.positions.filter(x => x.distance == distance).length;
        });

        return positionCount;
    };

    const getDepthCounts = () => {
        let depths = _.sortBy(_.uniq(props.swaps.map(x => x.depth)), depth => depth);

        let results = depths.map(depth => {
            let f = props.swaps.filter(x => x.depth == depth);

            return {
                depth,
                count: f.length
            }
        });

        return results;
    }

    const chains = _.range(1, props.deepestChainDepth + 1);

    const loopDepths = getDepthCounts();

    if (props.deepestChainDepth == 0)
        return null;

    if (props.isLoopRun)
        return (
            <>
                <RowWrapper className='row row-header'>
                    <div className='col-xs-6 header'>
                        Loop Depth
                    </div>
                    <div className='col-xs-6 header'>
                        Loop Count
                    </div>
                </RowWrapper>

                <div className='row-tbody'>
                    {loopDepths.map((item, index) =>
                        <RowWrapper key={'st-depth-' + index} className='row'>
                            <div className='col-xs-6 col-left'>{item.depth}</div>
                            <div className='col-xs-6 col-right'>{item.count}</div>
                        </RowWrapper>
                    )}
                </div>
            </>
        );

    return (
        <>
            <RowWrapper className='row row-header'>
                <div className='col-xs-6 header'>
                    String Depth
                </div>
                <div className='col-xs-6 header'>
                    Count
                </div>
            </RowWrapper>

            <div className='row-tbody'>
                {chains.map(index => {
                    let positionCount = getPositionCount(index);

                    return (
                        <RowWrapper key={'st-depth-' + index} className='row'>
                            <div className='col-xs-6 col-left'>{index}</div>
                            <div className='col-xs-6 col-right'>{positionCount}</div>
                        </RowWrapper>
                    );
                })}
            </div>
        </>
    );
}

export default StringDepth;